import * as ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettings from './restaurants-menu-settings-v1-menu-ordering-settings-menu-ordering-settings.http.js';
import * as ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes from './restaurants-menu-settings-v1-menu-ordering-settings-menu-ordering-settings.types.js';
import * as ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes from './restaurants-menu-settings-v1-menu-ordering-settings-menu-ordering-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getMenuOrderingSettings(): __PublicMethodMetaInfo<
  'GET',
  { menuOrderingSettingsId: string },
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.GetMenuOrderingSettingsRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.GetMenuOrderingSettingsRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.GetMenuOrderingSettingsResponse,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.GetMenuOrderingSettingsResponse
> {
  const payload = { menuOrderingSettingsId: ':menuOrderingSettingsId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettings.getMenuOrderingSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/menu-ordering-settings/{menuOrderingSettingsId}',
    pathParams: { menuOrderingSettingsId: 'menuOrderingSettingsId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function upsertMenuOrderingSettingsByMenuId(): __PublicMethodMetaInfo<
  'POST',
  { menuOrderingSettingsMenuId: string },
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.UpsertMenuOrderingSettingsByMenuIdRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.UpsertMenuOrderingSettingsByMenuIdRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.UpsertMenuOrderingSettingsByMenuIdResponse,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.UpsertMenuOrderingSettingsByMenuIdResponse
> {
  const payload = {
    menuOrderingSettings: { menuId: ':menuOrderingSettingsMenuId' },
  } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettings.upsertMenuOrderingSettingsByMenuId(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/menu-ordering-settings/upsert/menu-id/{menuOrderingSettings.menuId}',
    pathParams: { menuOrderingSettingsMenuId: 'menuOrderingSettingsMenuId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateMenuOrderingSettings(): __PublicMethodMetaInfo<
  'PATCH',
  { menuOrderingSettingsId: string },
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.UpdateMenuOrderingSettingsRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.UpdateMenuOrderingSettingsRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.UpdateMenuOrderingSettingsResponse,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.UpdateMenuOrderingSettingsResponse
> {
  const payload = {
    menuOrderingSettings: { id: ':menuOrderingSettingsId' },
  } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettings.updateMenuOrderingSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/menu-ordering-settings/{menuOrderingSettings.id}',
    pathParams: { menuOrderingSettingsId: 'menuOrderingSettingsId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryMenuOrderingSettings(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.QueryMenuOrderingSettingsRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.QueryMenuOrderingSettingsRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.QueryMenuOrderingSettingsResponse,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.QueryMenuOrderingSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettings.queryMenuOrderingSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/menu-ordering-settings/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateMenuOrderingSettings(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.BulkUpdateMenuOrderingSettingsRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.BulkUpdateMenuOrderingSettingsRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.BulkUpdateMenuOrderingSettingsResponse,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.BulkUpdateMenuOrderingSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettings.bulkUpdateMenuOrderingSettings(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/menu-ordering-settings/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listMenusAvailabilityStatus(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.ListMenusAvailabilityStatusRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.ListMenusAvailabilityStatusRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.ListMenusAvailabilityStatusResponse,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.ListMenusAvailabilityStatusResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettings.listMenusAvailabilityStatus(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/menu-ordering-settings/menus-availability-status',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateExtendedFields(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.UpdateExtendedFieldsRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.UpdateExtendedFieldsRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.UpdateExtendedFieldsResponse,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.UpdateExtendedFieldsResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettings.updateExtendedFields(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/menu-ordering-settings/{id}/update-extended-fields',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateMenuOrderingSettingsTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.BulkUpdateMenuOrderingSettingsTagsRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.BulkUpdateMenuOrderingSettingsTagsRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.BulkUpdateMenuOrderingSettingsTagsResponse,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.BulkUpdateMenuOrderingSettingsTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettings.bulkUpdateMenuOrderingSettingsTags(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/menu-ordering-settings/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateMenuOrderingSettingsTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.BulkUpdateMenuOrderingSettingsTagsByFilterRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.BulkUpdateMenuOrderingSettingsTagsByFilterRequest,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsUniversalTypes.BulkUpdateMenuOrderingSettingsTagsByFilterResponse,
  ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettingsTypes.BulkUpdateMenuOrderingSettingsTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsMenuSettingsV1MenuOrderingSettings.bulkUpdateMenuOrderingSettingsTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/menu-ordering-settings/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  MenuOrderingSettings as MenuOrderingSettingsOriginal,
  Availability as AvailabilityOriginal,
  AvailabilityAvailabilityTypeOptionsOneOf as AvailabilityAvailabilityTypeOptionsOneOfOriginal,
  AvailabilityType as AvailabilityTypeOriginal,
  AvailabilityTypeWithLiterals as AvailabilityTypeWithLiteralsOriginal,
  WeeklyScheduleOptions as WeeklyScheduleOptionsOriginal,
  DayOfWeekAvailability as DayOfWeekAvailabilityOriginal,
  EntitiesDayOfWeek as EntitiesDayOfWeekOriginal,
  EntitiesDayOfWeekWithLiterals as EntitiesDayOfWeekWithLiteralsOriginal,
  TimeOfDayRange as TimeOfDayRangeOriginal,
  TimeOfDay as TimeOfDayOriginal,
  TimestampRangesOptions as TimestampRangesOptionsOriginal,
  AvailableRange as AvailableRangeOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  CreateMenuOrderingSettingsRequest as CreateMenuOrderingSettingsRequestOriginal,
  CreateMenuOrderingSettingsResponse as CreateMenuOrderingSettingsResponseOriginal,
  GetMenuOrderingSettingsRequest as GetMenuOrderingSettingsRequestOriginal,
  GetMenuOrderingSettingsResponse as GetMenuOrderingSettingsResponseOriginal,
  UpsertMenuOrderingSettingsByMenuIdRequest as UpsertMenuOrderingSettingsByMenuIdRequestOriginal,
  UpsertMenuOrderingSettingsByMenuIdResponse as UpsertMenuOrderingSettingsByMenuIdResponseOriginal,
  UpdateMenuOrderingSettingsRequest as UpdateMenuOrderingSettingsRequestOriginal,
  UpdateMenuOrderingSettingsResponse as UpdateMenuOrderingSettingsResponseOriginal,
  DeleteMenuOrderingSettingsRequest as DeleteMenuOrderingSettingsRequestOriginal,
  DeleteMenuOrderingSettingsResponse as DeleteMenuOrderingSettingsResponseOriginal,
  QueryMenuOrderingSettingsRequest as QueryMenuOrderingSettingsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryMenuOrderingSettingsResponse as QueryMenuOrderingSettingsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  BulkUpdateMenuOrderingSettingsRequest as BulkUpdateMenuOrderingSettingsRequestOriginal,
  MaskedMenuOrderingSettings as MaskedMenuOrderingSettingsOriginal,
  BulkUpdateMenuOrderingSettingsResponse as BulkUpdateMenuOrderingSettingsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkMenuOrderingSettingsResult as BulkMenuOrderingSettingsResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  ListMenusAvailabilityStatusRequest as ListMenusAvailabilityStatusRequestOriginal,
  TimeSlot as TimeSlotOriginal,
  ListMenusAvailabilityStatusResponse as ListMenusAvailabilityStatusResponseOriginal,
  MenuAvailabilityStatus as MenuAvailabilityStatusOriginal,
  AvailabilityStatus as AvailabilityStatusOriginal,
  AvailabilityStatusWithLiterals as AvailabilityStatusWithLiteralsOriginal,
  UpdateExtendedFieldsRequest as UpdateExtendedFieldsRequestOriginal,
  UpdateExtendedFieldsResponse as UpdateExtendedFieldsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  GetRestaurantsAppClonesStatusRequest as GetRestaurantsAppClonesStatusRequestOriginal,
  GetRestaurantsAppClonesStatusResponse as GetRestaurantsAppClonesStatusResponseOriginal,
  RestaurantsAppCloneStatus as RestaurantsAppCloneStatusOriginal,
  SitePropertiesNotification as SitePropertiesNotificationOriginal,
  SitePropertiesEvent as SitePropertiesEventOriginal,
  Properties as PropertiesOriginal,
  Categories as CategoriesOriginal,
  Locale as LocaleOriginal,
  Address as AddressOriginal,
  AddressHint as AddressHintOriginal,
  PlacementType as PlacementTypeOriginal,
  PlacementTypeWithLiterals as PlacementTypeWithLiteralsOriginal,
  GeoCoordinates as GeoCoordinatesOriginal,
  BusinessSchedule as BusinessScheduleOriginal,
  TimePeriod as TimePeriodOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  SpecialHourPeriod as SpecialHourPeriodOriginal,
  Multilingual as MultilingualOriginal,
  SupportedLanguage as SupportedLanguageOriginal,
  ResolutionMethod as ResolutionMethodOriginal,
  ResolutionMethodWithLiterals as ResolutionMethodWithLiteralsOriginal,
  ConsentPolicy as ConsentPolicyOriginal,
  Translation as TranslationOriginal,
  ChangeContext as ChangeContextOriginal,
  ChangeContextPayloadOneOf as ChangeContextPayloadOneOfOriginal,
  PropertiesChange as PropertiesChangeOriginal,
  SiteCreated as SiteCreatedOriginal,
  SiteCloned as SiteClonedOriginal,
  OperationsDataCloningCompleted as OperationsDataCloningCompletedOriginal,
  MenusDataCloningCompleted as MenusDataCloningCompletedOriginal,
  BulkUpdateMenuOrderingSettingsTagsRequest as BulkUpdateMenuOrderingSettingsTagsRequestOriginal,
  BulkUpdateMenuOrderingSettingsTagsResponse as BulkUpdateMenuOrderingSettingsTagsResponseOriginal,
  CommonItemMetadata as CommonItemMetadataOriginal,
  BulkUpdateMenuOrderingSettingsTagsResult as BulkUpdateMenuOrderingSettingsTagsResultOriginal,
  CommonBulkActionMetadata as CommonBulkActionMetadataOriginal,
  BulkUpdateMenuOrderingSettingsTagsByFilterRequest as BulkUpdateMenuOrderingSettingsTagsByFilterRequestOriginal,
  BulkUpdateMenuOrderingSettingsTagsByFilterResponse as BulkUpdateMenuOrderingSettingsTagsByFilterResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  BulkUpdateMenuOrderingSettingsTagsApplicationErrors as BulkUpdateMenuOrderingSettingsTagsApplicationErrorsOriginal,
  BulkUpdateMenuOrderingSettingsTagsByFilterApplicationErrors as BulkUpdateMenuOrderingSettingsTagsByFilterApplicationErrorsOriginal,
} from './restaurants-menu-settings-v1-menu-ordering-settings-menu-ordering-settings.types.js';
